import { render, staticRenderFns } from "./LogoBio.vue?vue&type=template&id=7628979d&scoped=true&"
var script = {}
import style0 from "./LogoBio.vue?vue&type=style&index=0&id=7628979d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7628979d",
  null
  
)

export default component.exports